export default "__VITE_ASSET__XwXLqNN8__"